import React from 'react';
import { compose } from 'ramda';
import { SlideContext } from './slideContext';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './SlideMultiWrapper.js';


const SlideMultiWrapper = class SlideMultiWrapper extends React.Component {
  static contextType = SlideContext;

  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      moving: false,
      movementX: 0,
      touchStart: 0,
    };

    this.myInput = React.createRef()
    
  }

  componentDidMount () {
    this.setState(state => {
      return {
        width: this.myInput.current.offsetWidth
      };
    });

    if(this.context.autoPlay) {
      window.setInterval(() => {
        this.context.next()
      }, this.context.autoPlaySpeed);
    }
    
  }

  onMouseDown = (event) => {
    event && event.preventDefault()
    this.setState({
      moving: true,
    })
  }

  onMouseMove = (event) => {
    event && event.preventDefault()    
    if(this.state.moving) {
      this.setState({
        movementX: this.state.movementX + event.movementX
      })
    }
  }

  onMouseUp = (event) => {
    event && event.preventDefault()    
    this.setState({
      moving: false,
      movementX: 0
    })
    this.context.goTo(this.context.position + Math.round(- this.state.movementX / (this.myInput.current.offsetWidth / this.context.slides.length)))
  }

  onTouchStart = (event) => {
    this.setState({
      moving: true,
      touchStart: event.touches[0].clientX
    })
  }
  
  onTouchMove = (event) => {
    if(this.state.moving) {
      this.setState({
        movementX: this.state.movementX + event.touches[0].clientX - this.state.touchStart,
        touchStart: event.touches[0].clientX
      })
    }
  }

  onTouchEnd = (event) => {
    this.setState({
      moving: false,
      movementX: 0,
      touchStart: 0
    })
    this.context.goTo(this.context.position + Math.round(- this.state.movementX / (this.myInput.current.offsetWidth / this.context.slides.length)))
  }

  
  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;
    const { visibleItems, slides, position, customTransition, transitionDuration, touchDraggable, cursorDraggable, itemsGap } = this.context;
    
    let transform = 'transform ' + transitionDuration + 'ms ease-in-out'
    if(customTransition) {
      transform = customTransition
    }
    
    var translate = 'calc( -100% / ' + slides.length + ' * ' + position + ' + ' + this.state.movementX + 'px - ' + ' ( ' + itemsGap + 'px / ' + slides.length + ' * ' + position + ' ) )';
    let width = 'calc(100% / ' + visibleItems + ' * ' + slides.length + ' + ( ' + ((itemsGap/visibleItems) * (slides.length-visibleItems)) + 'px ) )'
    
    return (
      <div
        onMouseDown={cursorDraggable ? this.onMouseDown : null}
        onMouseMove={cursorDraggable ? this.onMouseMove : null}
        onMouseUp={cursorDraggable ? this.onMouseUp : null}
        onTouchStart={touchDraggable ? this.onTouchStart : null}
        onTouchMove={touchDraggable ? this.onTouchMove : null}
        onTouchEnd={touchDraggable ? this.onTouchEnd : null}
        className={classes.slideMultiWrapperList}
      >
        <div
          ref={this.myInput}
          className={classes.slideMultiWrapperTrack}
          style={{
            //width: 'calc(100% / ' + visibleItems + ' * ' + slides.length + ')',
            width: width,
            transform: 'translateX(' + translate + ')',
            transition: !this.state.moving ? transform : 'none',
            gap: itemsGap + 'px'
          }}
        >
          {slides && slides.map((slide, index) => {
            return (
              <div key={index} className={classes.slideItemWrapper} onClick={() => this.props.config.onClick}>
                {slide}
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}


export default compose(
  PropertyManager([
    'children',
  ]),
  withThemeJSS({ styleFile, displayName: 'SlideMultiWrapper' })
)(SlideMultiWrapper);